import { AsyncHorizontalOverviewNav } from '@atlassian/jira-business-horizontal-nav/src/async.tsx';
import { globalLayout } from '@atlassian/jira-global-layout/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarCore from '@atlassian/jira-navigation-apps-sidebar-core/src/async.tsx';
import { ThemedLazySkeleton } from '@atlassian/jira-project-theme-components/src/ui/ThemedLazySkeleton.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getOverviewViewResources } from '@atlassian/jira-router-resources-business-common/src/index.tsx';
import { classicBusinessOverviewSummaryRoute } from '@atlassian/jira-router-routes-business-routes/src/classicBusinessOverviewSummaryRoute.tsx';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { overviewSummaryEntrypoint } from '@atlassian/jira-spa-apps-business-overview-summary/entrypoint.tsx';

const overviewSummaryPageEntrypoint = createPageEntryPoint({
	main: overviewSummaryEntrypoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
});

export const classicBusinessOverviewSummaryRouteEntry = createEntry(
	classicBusinessOverviewSummaryRoute,
	() => ({
		group: 'classic-business',
		layout: globalLayout,
		skeleton: ThemedLazySkeleton,

		navigation: {
			menuId: MENU_ID.PROJECTS,
			sidebar: AsyncSidebarCore,
			horizontal: AsyncHorizontalOverviewNav,
		},

		resources: getOverviewViewResources(),

		entryPoint: () => overviewSummaryPageEntrypoint,
	}),
);
